import axios from '@/js/plugins/client'
export default {
  alias      : 'tramite_tipo_documento',
  route      : '/app/tramite/tipo_documento',
  hash       : false,
  store      : false,
  key        : 'idtdoc',
  name       : 'tdoc_descripcion',
  selectable : false,
  default    : {
    idtdoc           : null,
    tdoc_descripcion : null,
    tdoc_abreviado   : null,
    tdoc_correlativo : null,
    created_at       : null,
    updated_at       : null,
    tdoc_mpv         : null,
    tdoc_imp         : null,
  },
  methods : {
    obtenerMPV() {
      return new Promise((resolve, reject) => {
        axios.get('/tramite/tipoDocumento/mpv').then(response => {
          resolve(response)
        })
          .catch(reject)
      })
    },
  }

}
